// extracted by mini-css-extract-plugin
module.exports = {"link":"link__3NB-l","wrap":"wrap__PabRR","arrow":"arrow__1G4Oi","right":"right__1R5nd","left":"left__xhCGA"};